// source: entity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var general_pb = require('./general_pb.js');
goog.object.extend(proto, general_pb);
var storage_pb = require('./storage_pb.js');
goog.object.extend(proto, storage_pb);
var enums_pb = require('./enums_pb.js');
goog.object.extend(proto, enums_pb);
goog.exportSymbol('proto.cloud.Entity', null, global);
goog.exportSymbol('proto.cloud.EntityInfoExpansionRequest', null, global);
goog.exportSymbol('proto.cloud.EntitySignedDownload', null, global);
goog.exportSymbol('proto.cloud.ExpandedEntity', null, global);
goog.exportSymbol('proto.cloud.ExpandedEntityDerivative', null, global);
goog.exportSymbol('proto.cloud.JobMembership', null, global);
goog.exportSymbol('proto.cloud.JobMembership.JobMembershipItem', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobMembership = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.JobMembership.repeatedFields_, null);
};
goog.inherits(proto.cloud.JobMembership, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobMembership.displayName = 'proto.cloud.JobMembership';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobMembership.JobMembershipItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.JobMembership.JobMembershipItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobMembership.JobMembershipItem.displayName = 'proto.cloud.JobMembership.JobMembershipItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.Entity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.Entity.repeatedFields_, null);
};
goog.inherits(proto.cloud.Entity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.Entity.displayName = 'proto.cloud.Entity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.EntitySignedDownload = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.EntitySignedDownload, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.EntitySignedDownload.displayName = 'proto.cloud.EntitySignedDownload';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.ExpandedEntityDerivative = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.ExpandedEntityDerivative, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.ExpandedEntityDerivative.displayName = 'proto.cloud.ExpandedEntityDerivative';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.EntityInfoExpansionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.EntityInfoExpansionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.EntityInfoExpansionRequest.displayName = 'proto.cloud.EntityInfoExpansionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.ExpandedEntity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.ExpandedEntity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.ExpandedEntity.displayName = 'proto.cloud.ExpandedEntity';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.JobMembership.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobMembership.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobMembership.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobMembership} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobMembership.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.cloud.JobMembership.JobMembershipItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobMembership}
 */
proto.cloud.JobMembership.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobMembership;
  return proto.cloud.JobMembership.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobMembership} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobMembership}
 */
proto.cloud.JobMembership.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 4:
      var value = new proto.cloud.JobMembership.JobMembershipItem;
      reader.readMessage(value,proto.cloud.JobMembership.JobMembershipItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobMembership.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobMembership.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobMembership} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobMembership.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.cloud.JobMembership.JobMembershipItem.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobMembership.JobMembershipItem.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobMembership.JobMembershipItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobMembership.JobMembershipItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobMembership.JobMembershipItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    folderId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    fileId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    type: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobMembership.JobMembershipItem}
 */
proto.cloud.JobMembership.JobMembershipItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobMembership.JobMembershipItem;
  return proto.cloud.JobMembership.JobMembershipItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobMembership.JobMembershipItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobMembership.JobMembershipItem}
 */
proto.cloud.JobMembership.JobMembershipItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFolderId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFileId(value);
      break;
    case 6:
      var value = /** @type {!proto.cloud.JobMemershipType} */ (reader.readEnum());
      msg.setType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobMembership.JobMembershipItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobMembership.JobMembershipItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobMembership.JobMembershipItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobMembership.JobMembershipItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFolderId();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getFileId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.cloud.JobMembership.JobMembershipItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobMembership.JobMembershipItem} returns this
 */
proto.cloud.JobMembership.JobMembershipItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 folder_id = 4;
 * @return {number}
 */
proto.cloud.JobMembership.JobMembershipItem.prototype.getFolderId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobMembership.JobMembershipItem} returns this
 */
proto.cloud.JobMembership.JobMembershipItem.prototype.setFolderId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 file_id = 5;
 * @return {number}
 */
proto.cloud.JobMembership.JobMembershipItem.prototype.getFileId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobMembership.JobMembershipItem} returns this
 */
proto.cloud.JobMembership.JobMembershipItem.prototype.setFileId = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional JobMemershipType type = 6;
 * @return {!proto.cloud.JobMemershipType}
 */
proto.cloud.JobMembership.JobMembershipItem.prototype.getType = function() {
  return /** @type {!proto.cloud.JobMemershipType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.cloud.JobMemershipType} value
 * @return {!proto.cloud.JobMembership.JobMembershipItem} returns this
 */
proto.cloud.JobMembership.JobMembershipItem.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.cloud.JobMembership.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobMembership} returns this
 */
proto.cloud.JobMembership.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_name = 3;
 * @return {string}
 */
proto.cloud.JobMembership.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobMembership} returns this
 */
proto.cloud.JobMembership.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated JobMembershipItem items = 4;
 * @return {!Array<!proto.cloud.JobMembership.JobMembershipItem>}
 */
proto.cloud.JobMembership.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.cloud.JobMembership.JobMembershipItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.JobMembership.JobMembershipItem, 4));
};


/**
 * @param {!Array<!proto.cloud.JobMembership.JobMembershipItem>} value
 * @return {!proto.cloud.JobMembership} returns this
*/
proto.cloud.JobMembership.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.cloud.JobMembership.JobMembershipItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.JobMembership.JobMembershipItem}
 */
proto.cloud.JobMembership.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.cloud.JobMembership.JobMembershipItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobMembership} returns this
 */
proto.cloud.JobMembership.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.Entity.repeatedFields_ = [32,34,36,38,50];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.Entity.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.Entity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.Entity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Entity.toObject = function(includeInstance, msg) {
  var f, obj = {
    projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    size: jspb.Message.getFieldWithDefault(msg, 4, 0),
    checksum: jspb.Message.getFieldWithDefault(msg, 5, ""),
    type: jspb.Message.getFieldWithDefault(msg, 6, 0),
    name: jspb.Message.getFieldWithDefault(msg, 7, ""),
    alternateChecksums: (f = msg.getAlternateChecksums()) && general_pb.Checksum.toObject(includeInstance, f),
    dateLastUpdated: jspb.Message.getFieldWithDefault(msg, 11, ""),
    format: jspb.Message.getFieldWithDefault(msg, 12, ""),
    frameRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    width: jspb.Message.getFieldWithDefault(msg, 14, 0),
    height: jspb.Message.getFieldWithDefault(msg, 15, 0),
    bitRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    bitDepth: jspb.Message.getFieldWithDefault(msg, 17, 0),
    sampleRate: jspb.Message.getFieldWithDefault(msg, 18, 0),
    expandedMetadataMap: (f = msg.getExpandedMetadataMap()) ? f.toObject(includeInstance, undefined) : [],
    wasMetadataExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
    expandedJobMembershipList: jspb.Message.toObjectList(msg.getExpandedJobMembershipList(),
    proto.cloud.JobMembership.toObject, includeInstance),
    wasJobMembershipExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 33, false),
    expandedTagsList: jspb.Message.toObjectList(msg.getExpandedTagsList(),
    general_pb.Tag.toObject, includeInstance),
    wereTagsExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 35, false),
    expandedDerivativesList: jspb.Message.toObjectList(msg.getExpandedDerivativesList(),
    proto.cloud.ExpandedEntityDerivative.toObject, includeInstance),
    derivativesWereExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 37, false),
    expandedOriginEntitiesList: jspb.Message.toObjectList(msg.getExpandedOriginEntitiesList(),
    proto.cloud.ExpandedEntityDerivative.toObject, includeInstance),
    originEntitiesWereExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 39, false),
    expandedDownloadsList: jspb.Message.toObjectList(msg.getExpandedDownloadsList(),
    proto.cloud.EntitySignedDownload.toObject, includeInstance),
    downloadsWereExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 51, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.Entity}
 */
proto.cloud.Entity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.Entity;
  return proto.cloud.Entity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.Entity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.Entity}
 */
proto.cloud.Entity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setChecksum(value);
      break;
    case 6:
      var value = /** @type {!proto.cloud.EntityType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = new general_pb.Checksum;
      reader.readMessage(value,general_pb.Checksum.deserializeBinaryFromReader);
      msg.setAlternateChecksums(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateLastUpdated(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormat(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFrameRate(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWidth(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHeight(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBitRate(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBitDepth(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSampleRate(value);
      break;
    case 30:
      var value = msg.getExpandedMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWasMetadataExpanded(value);
      break;
    case 32:
      var value = new proto.cloud.JobMembership;
      reader.readMessage(value,proto.cloud.JobMembership.deserializeBinaryFromReader);
      msg.addExpandedJobMembership(value);
      break;
    case 33:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWasJobMembershipExpanded(value);
      break;
    case 34:
      var value = new general_pb.Tag;
      reader.readMessage(value,general_pb.Tag.deserializeBinaryFromReader);
      msg.addExpandedTags(value);
      break;
    case 35:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWereTagsExpanded(value);
      break;
    case 36:
      var value = new proto.cloud.ExpandedEntityDerivative;
      reader.readMessage(value,proto.cloud.ExpandedEntityDerivative.deserializeBinaryFromReader);
      msg.addExpandedDerivatives(value);
      break;
    case 37:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDerivativesWereExpanded(value);
      break;
    case 38:
      var value = new proto.cloud.ExpandedEntityDerivative;
      reader.readMessage(value,proto.cloud.ExpandedEntityDerivative.deserializeBinaryFromReader);
      msg.addExpandedOriginEntities(value);
      break;
    case 39:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOriginEntitiesWereExpanded(value);
      break;
    case 50:
      var value = new proto.cloud.EntitySignedDownload;
      reader.readMessage(value,proto.cloud.EntitySignedDownload.deserializeBinaryFromReader);
      msg.addExpandedDownloads(value);
      break;
    case 51:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDownloadsWereExpanded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.Entity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.Entity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.Entity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.Entity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getChecksum();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAlternateChecksums();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      general_pb.Checksum.serializeBinaryToWriter
    );
  }
  f = message.getDateLastUpdated();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFormat();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getFrameRate();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getBitRate();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getBitDepth();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getSampleRate();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getExpandedMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(30, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getWasMetadataExpanded();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = message.getExpandedJobMembershipList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      32,
      f,
      proto.cloud.JobMembership.serializeBinaryToWriter
    );
  }
  f = message.getWasJobMembershipExpanded();
  if (f) {
    writer.writeBool(
      33,
      f
    );
  }
  f = message.getExpandedTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      34,
      f,
      general_pb.Tag.serializeBinaryToWriter
    );
  }
  f = message.getWereTagsExpanded();
  if (f) {
    writer.writeBool(
      35,
      f
    );
  }
  f = message.getExpandedDerivativesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      36,
      f,
      proto.cloud.ExpandedEntityDerivative.serializeBinaryToWriter
    );
  }
  f = message.getDerivativesWereExpanded();
  if (f) {
    writer.writeBool(
      37,
      f
    );
  }
  f = message.getExpandedOriginEntitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      38,
      f,
      proto.cloud.ExpandedEntityDerivative.serializeBinaryToWriter
    );
  }
  f = message.getOriginEntitiesWereExpanded();
  if (f) {
    writer.writeBool(
      39,
      f
    );
  }
  f = message.getExpandedDownloadsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      50,
      f,
      proto.cloud.EntitySignedDownload.serializeBinaryToWriter
    );
  }
  f = message.getDownloadsWereExpanded();
  if (f) {
    writer.writeBool(
      51,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.cloud.Entity.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.cloud.Entity.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 size = 4;
 * @return {number}
 */
proto.cloud.Entity.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string checksum = 5;
 * @return {string}
 */
proto.cloud.Entity.prototype.getChecksum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setChecksum = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional EntityType type = 6;
 * @return {!proto.cloud.EntityType}
 */
proto.cloud.Entity.prototype.getType = function() {
  return /** @type {!proto.cloud.EntityType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.cloud.EntityType} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string name = 7;
 * @return {string}
 */
proto.cloud.Entity.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional Checksum alternate_checksums = 8;
 * @return {?proto.cloud.Checksum}
 */
proto.cloud.Entity.prototype.getAlternateChecksums = function() {
  return /** @type{?proto.cloud.Checksum} */ (
    jspb.Message.getWrapperField(this, general_pb.Checksum, 8));
};


/**
 * @param {?proto.cloud.Checksum|undefined} value
 * @return {!proto.cloud.Entity} returns this
*/
proto.cloud.Entity.prototype.setAlternateChecksums = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.clearAlternateChecksums = function() {
  return this.setAlternateChecksums(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.Entity.prototype.hasAlternateChecksums = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string date_last_updated = 11;
 * @return {string}
 */
proto.cloud.Entity.prototype.getDateLastUpdated = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setDateLastUpdated = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string format = 12;
 * @return {string}
 */
proto.cloud.Entity.prototype.getFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setFormat = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional double frame_rate = 13;
 * @return {number}
 */
proto.cloud.Entity.prototype.getFrameRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setFrameRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional int64 width = 14;
 * @return {number}
 */
proto.cloud.Entity.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 height = 15;
 * @return {number}
 */
proto.cloud.Entity.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional double bit_rate = 16;
 * @return {number}
 */
proto.cloud.Entity.prototype.getBitRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setBitRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional int64 bit_depth = 17;
 * @return {number}
 */
proto.cloud.Entity.prototype.getBitDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setBitDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 sample_rate = 18;
 * @return {number}
 */
proto.cloud.Entity.prototype.getSampleRate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setSampleRate = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * map<string, string> expanded_metadata = 30;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.cloud.Entity.prototype.getExpandedMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 30, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.clearExpandedMetadataMap = function() {
  this.getExpandedMetadataMap().clear();
  return this;};


/**
 * optional bool was_metadata_expanded = 31;
 * @return {boolean}
 */
proto.cloud.Entity.prototype.getWasMetadataExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setWasMetadataExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * repeated JobMembership expanded_job_membership = 32;
 * @return {!Array<!proto.cloud.JobMembership>}
 */
proto.cloud.Entity.prototype.getExpandedJobMembershipList = function() {
  return /** @type{!Array<!proto.cloud.JobMembership>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.JobMembership, 32));
};


/**
 * @param {!Array<!proto.cloud.JobMembership>} value
 * @return {!proto.cloud.Entity} returns this
*/
proto.cloud.Entity.prototype.setExpandedJobMembershipList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 32, value);
};


/**
 * @param {!proto.cloud.JobMembership=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.JobMembership}
 */
proto.cloud.Entity.prototype.addExpandedJobMembership = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 32, opt_value, proto.cloud.JobMembership, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.clearExpandedJobMembershipList = function() {
  return this.setExpandedJobMembershipList([]);
};


/**
 * optional bool was_job_membership_expanded = 33;
 * @return {boolean}
 */
proto.cloud.Entity.prototype.getWasJobMembershipExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 33, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setWasJobMembershipExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 33, value);
};


/**
 * repeated Tag expanded_tags = 34;
 * @return {!Array<!proto.cloud.Tag>}
 */
proto.cloud.Entity.prototype.getExpandedTagsList = function() {
  return /** @type{!Array<!proto.cloud.Tag>} */ (
    jspb.Message.getRepeatedWrapperField(this, general_pb.Tag, 34));
};


/**
 * @param {!Array<!proto.cloud.Tag>} value
 * @return {!proto.cloud.Entity} returns this
*/
proto.cloud.Entity.prototype.setExpandedTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 34, value);
};


/**
 * @param {!proto.cloud.Tag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.Tag}
 */
proto.cloud.Entity.prototype.addExpandedTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 34, opt_value, proto.cloud.Tag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.clearExpandedTagsList = function() {
  return this.setExpandedTagsList([]);
};


/**
 * optional bool were_tags_expanded = 35;
 * @return {boolean}
 */
proto.cloud.Entity.prototype.getWereTagsExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 35, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setWereTagsExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 35, value);
};


/**
 * repeated ExpandedEntityDerivative expanded_derivatives = 36;
 * @return {!Array<!proto.cloud.ExpandedEntityDerivative>}
 */
proto.cloud.Entity.prototype.getExpandedDerivativesList = function() {
  return /** @type{!Array<!proto.cloud.ExpandedEntityDerivative>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.ExpandedEntityDerivative, 36));
};


/**
 * @param {!Array<!proto.cloud.ExpandedEntityDerivative>} value
 * @return {!proto.cloud.Entity} returns this
*/
proto.cloud.Entity.prototype.setExpandedDerivativesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 36, value);
};


/**
 * @param {!proto.cloud.ExpandedEntityDerivative=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.ExpandedEntityDerivative}
 */
proto.cloud.Entity.prototype.addExpandedDerivatives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 36, opt_value, proto.cloud.ExpandedEntityDerivative, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.clearExpandedDerivativesList = function() {
  return this.setExpandedDerivativesList([]);
};


/**
 * optional bool derivatives_were_expanded = 37;
 * @return {boolean}
 */
proto.cloud.Entity.prototype.getDerivativesWereExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 37, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setDerivativesWereExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 37, value);
};


/**
 * repeated ExpandedEntityDerivative expanded_origin_entities = 38;
 * @return {!Array<!proto.cloud.ExpandedEntityDerivative>}
 */
proto.cloud.Entity.prototype.getExpandedOriginEntitiesList = function() {
  return /** @type{!Array<!proto.cloud.ExpandedEntityDerivative>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.ExpandedEntityDerivative, 38));
};


/**
 * @param {!Array<!proto.cloud.ExpandedEntityDerivative>} value
 * @return {!proto.cloud.Entity} returns this
*/
proto.cloud.Entity.prototype.setExpandedOriginEntitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 38, value);
};


/**
 * @param {!proto.cloud.ExpandedEntityDerivative=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.ExpandedEntityDerivative}
 */
proto.cloud.Entity.prototype.addExpandedOriginEntities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 38, opt_value, proto.cloud.ExpandedEntityDerivative, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.clearExpandedOriginEntitiesList = function() {
  return this.setExpandedOriginEntitiesList([]);
};


/**
 * optional bool origin_entities_were_expanded = 39;
 * @return {boolean}
 */
proto.cloud.Entity.prototype.getOriginEntitiesWereExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 39, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setOriginEntitiesWereExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 39, value);
};


/**
 * repeated EntitySignedDownload expanded_downloads = 50;
 * @return {!Array<!proto.cloud.EntitySignedDownload>}
 */
proto.cloud.Entity.prototype.getExpandedDownloadsList = function() {
  return /** @type{!Array<!proto.cloud.EntitySignedDownload>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.EntitySignedDownload, 50));
};


/**
 * @param {!Array<!proto.cloud.EntitySignedDownload>} value
 * @return {!proto.cloud.Entity} returns this
*/
proto.cloud.Entity.prototype.setExpandedDownloadsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 50, value);
};


/**
 * @param {!proto.cloud.EntitySignedDownload=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.EntitySignedDownload}
 */
proto.cloud.Entity.prototype.addExpandedDownloads = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 50, opt_value, proto.cloud.EntitySignedDownload, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.clearExpandedDownloadsList = function() {
  return this.setExpandedDownloadsList([]);
};


/**
 * optional bool downloads_were_expanded = 51;
 * @return {boolean}
 */
proto.cloud.Entity.prototype.getDownloadsWereExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 51, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.Entity} returns this
 */
proto.cloud.Entity.prototype.setDownloadsWereExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 51, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.EntitySignedDownload.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.EntitySignedDownload.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.EntitySignedDownload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.EntitySignedDownload.toObject = function(includeInstance, msg) {
  var f, obj = {
    download: (f = msg.getDownload()) && storage_pb.SignedDownload.toObject(includeInstance, f),
    isFinalized: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.EntitySignedDownload}
 */
proto.cloud.EntitySignedDownload.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.EntitySignedDownload;
  return proto.cloud.EntitySignedDownload.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.EntitySignedDownload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.EntitySignedDownload}
 */
proto.cloud.EntitySignedDownload.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new storage_pb.SignedDownload;
      reader.readMessage(value,storage_pb.SignedDownload.deserializeBinaryFromReader);
      msg.setDownload(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFinalized(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.EntitySignedDownload.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.EntitySignedDownload.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.EntitySignedDownload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.EntitySignedDownload.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDownload();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      storage_pb.SignedDownload.serializeBinaryToWriter
    );
  }
  f = message.getIsFinalized();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional SignedDownload download = 1;
 * @return {?proto.cloud.SignedDownload}
 */
proto.cloud.EntitySignedDownload.prototype.getDownload = function() {
  return /** @type{?proto.cloud.SignedDownload} */ (
    jspb.Message.getWrapperField(this, storage_pb.SignedDownload, 1));
};


/**
 * @param {?proto.cloud.SignedDownload|undefined} value
 * @return {!proto.cloud.EntitySignedDownload} returns this
*/
proto.cloud.EntitySignedDownload.prototype.setDownload = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.EntitySignedDownload} returns this
 */
proto.cloud.EntitySignedDownload.prototype.clearDownload = function() {
  return this.setDownload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.EntitySignedDownload.prototype.hasDownload = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool is_finalized = 2;
 * @return {boolean}
 */
proto.cloud.EntitySignedDownload.prototype.getIsFinalized = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.EntitySignedDownload} returns this
 */
proto.cloud.EntitySignedDownload.prototype.setIsFinalized = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.ExpandedEntityDerivative.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.ExpandedEntityDerivative.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.ExpandedEntityDerivative} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ExpandedEntityDerivative.toObject = function(includeInstance, msg) {
  var f, obj = {
    entity: (f = msg.getEntity()) && proto.cloud.Entity.toObject(includeInstance, f),
    derivativeType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    subSeries: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.ExpandedEntityDerivative}
 */
proto.cloud.ExpandedEntityDerivative.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.ExpandedEntityDerivative;
  return proto.cloud.ExpandedEntityDerivative.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.ExpandedEntityDerivative} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.ExpandedEntityDerivative}
 */
proto.cloud.ExpandedEntityDerivative.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud.Entity;
      reader.readMessage(value,proto.cloud.Entity.deserializeBinaryFromReader);
      msg.setEntity(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud.EntityDerivativeType} */ (reader.readEnum());
      msg.setDerivativeType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubSeries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.ExpandedEntityDerivative.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.ExpandedEntityDerivative.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.ExpandedEntityDerivative} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ExpandedEntityDerivative.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cloud.Entity.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSubSeries();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional Entity entity = 1;
 * @return {?proto.cloud.Entity}
 */
proto.cloud.ExpandedEntityDerivative.prototype.getEntity = function() {
  return /** @type{?proto.cloud.Entity} */ (
    jspb.Message.getWrapperField(this, proto.cloud.Entity, 1));
};


/**
 * @param {?proto.cloud.Entity|undefined} value
 * @return {!proto.cloud.ExpandedEntityDerivative} returns this
*/
proto.cloud.ExpandedEntityDerivative.prototype.setEntity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.ExpandedEntityDerivative} returns this
 */
proto.cloud.ExpandedEntityDerivative.prototype.clearEntity = function() {
  return this.setEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.ExpandedEntityDerivative.prototype.hasEntity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EntityDerivativeType derivative_type = 2;
 * @return {!proto.cloud.EntityDerivativeType}
 */
proto.cloud.ExpandedEntityDerivative.prototype.getDerivativeType = function() {
  return /** @type {!proto.cloud.EntityDerivativeType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud.EntityDerivativeType} value
 * @return {!proto.cloud.ExpandedEntityDerivative} returns this
 */
proto.cloud.ExpandedEntityDerivative.prototype.setDerivativeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 sub_series = 3;
 * @return {number}
 */
proto.cloud.ExpandedEntityDerivative.prototype.getSubSeries = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.ExpandedEntityDerivative} returns this
 */
proto.cloud.ExpandedEntityDerivative.prototype.setSubSeries = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.EntityInfoExpansionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.EntityInfoExpansionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.EntityInfoExpansionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.EntityInfoExpansionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    shouldExpandMetadata: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    shouldExpandTags: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    shouldExpandJobMembership: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    requestDownloads: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    requestDerivatives: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    requestDerivativeDownloads: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    requestOriginEntities: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    requestOriginDownloads: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.EntityInfoExpansionRequest}
 */
proto.cloud.EntityInfoExpansionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.EntityInfoExpansionRequest;
  return proto.cloud.EntityInfoExpansionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.EntityInfoExpansionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.EntityInfoExpansionRequest}
 */
proto.cloud.EntityInfoExpansionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldExpandMetadata(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldExpandTags(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldExpandJobMembership(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestDownloads(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestDerivatives(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestDerivativeDownloads(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestOriginEntities(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRequestOriginDownloads(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.EntityInfoExpansionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.EntityInfoExpansionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.EntityInfoExpansionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.EntityInfoExpansionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShouldExpandMetadata();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getShouldExpandTags();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getShouldExpandJobMembership();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getRequestDownloads();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getRequestDerivatives();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getRequestDerivativeDownloads();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getRequestOriginEntities();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getRequestOriginDownloads();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional bool should_expand_metadata = 1;
 * @return {boolean}
 */
proto.cloud.EntityInfoExpansionRequest.prototype.getShouldExpandMetadata = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.EntityInfoExpansionRequest} returns this
 */
proto.cloud.EntityInfoExpansionRequest.prototype.setShouldExpandMetadata = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool should_expand_tags = 2;
 * @return {boolean}
 */
proto.cloud.EntityInfoExpansionRequest.prototype.getShouldExpandTags = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.EntityInfoExpansionRequest} returns this
 */
proto.cloud.EntityInfoExpansionRequest.prototype.setShouldExpandTags = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool should_expand_job_membership = 3;
 * @return {boolean}
 */
proto.cloud.EntityInfoExpansionRequest.prototype.getShouldExpandJobMembership = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.EntityInfoExpansionRequest} returns this
 */
proto.cloud.EntityInfoExpansionRequest.prototype.setShouldExpandJobMembership = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool request_downloads = 4;
 * @return {boolean}
 */
proto.cloud.EntityInfoExpansionRequest.prototype.getRequestDownloads = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.EntityInfoExpansionRequest} returns this
 */
proto.cloud.EntityInfoExpansionRequest.prototype.setRequestDownloads = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool request_derivatives = 5;
 * @return {boolean}
 */
proto.cloud.EntityInfoExpansionRequest.prototype.getRequestDerivatives = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.EntityInfoExpansionRequest} returns this
 */
proto.cloud.EntityInfoExpansionRequest.prototype.setRequestDerivatives = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool request_derivative_downloads = 6;
 * @return {boolean}
 */
proto.cloud.EntityInfoExpansionRequest.prototype.getRequestDerivativeDownloads = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.EntityInfoExpansionRequest} returns this
 */
proto.cloud.EntityInfoExpansionRequest.prototype.setRequestDerivativeDownloads = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool request_origin_entities = 7;
 * @return {boolean}
 */
proto.cloud.EntityInfoExpansionRequest.prototype.getRequestOriginEntities = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.EntityInfoExpansionRequest} returns this
 */
proto.cloud.EntityInfoExpansionRequest.prototype.setRequestOriginEntities = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool request_origin_downloads = 8;
 * @return {boolean}
 */
proto.cloud.EntityInfoExpansionRequest.prototype.getRequestOriginDownloads = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.EntityInfoExpansionRequest} returns this
 */
proto.cloud.EntityInfoExpansionRequest.prototype.setRequestOriginDownloads = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.ExpandedEntity.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.ExpandedEntity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.ExpandedEntity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ExpandedEntity.toObject = function(includeInstance, msg) {
  var f, obj = {
    entity: (f = msg.getEntity()) && proto.cloud.Entity.toObject(includeInstance, f),
    download: (f = msg.getDownload()) && storage_pb.SignedDownload.toObject(includeInstance, f),
    derivativeType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    subSeries: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.ExpandedEntity}
 */
proto.cloud.ExpandedEntity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.ExpandedEntity;
  return proto.cloud.ExpandedEntity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.ExpandedEntity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.ExpandedEntity}
 */
proto.cloud.ExpandedEntity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud.Entity;
      reader.readMessage(value,proto.cloud.Entity.deserializeBinaryFromReader);
      msg.setEntity(value);
      break;
    case 2:
      var value = new storage_pb.SignedDownload;
      reader.readMessage(value,storage_pb.SignedDownload.deserializeBinaryFromReader);
      msg.setDownload(value);
      break;
    case 3:
      var value = /** @type {!proto.cloud.EntityDerivativeType} */ (reader.readEnum());
      msg.setDerivativeType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubSeries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.ExpandedEntity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.ExpandedEntity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.ExpandedEntity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.ExpandedEntity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cloud.Entity.serializeBinaryToWriter
    );
  }
  f = message.getDownload();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      storage_pb.SignedDownload.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSubSeries();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional Entity entity = 1;
 * @return {?proto.cloud.Entity}
 */
proto.cloud.ExpandedEntity.prototype.getEntity = function() {
  return /** @type{?proto.cloud.Entity} */ (
    jspb.Message.getWrapperField(this, proto.cloud.Entity, 1));
};


/**
 * @param {?proto.cloud.Entity|undefined} value
 * @return {!proto.cloud.ExpandedEntity} returns this
*/
proto.cloud.ExpandedEntity.prototype.setEntity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.ExpandedEntity} returns this
 */
proto.cloud.ExpandedEntity.prototype.clearEntity = function() {
  return this.setEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.ExpandedEntity.prototype.hasEntity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SignedDownload download = 2;
 * @return {?proto.cloud.SignedDownload}
 */
proto.cloud.ExpandedEntity.prototype.getDownload = function() {
  return /** @type{?proto.cloud.SignedDownload} */ (
    jspb.Message.getWrapperField(this, storage_pb.SignedDownload, 2));
};


/**
 * @param {?proto.cloud.SignedDownload|undefined} value
 * @return {!proto.cloud.ExpandedEntity} returns this
*/
proto.cloud.ExpandedEntity.prototype.setDownload = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.ExpandedEntity} returns this
 */
proto.cloud.ExpandedEntity.prototype.clearDownload = function() {
  return this.setDownload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.ExpandedEntity.prototype.hasDownload = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional EntityDerivativeType derivative_type = 3;
 * @return {!proto.cloud.EntityDerivativeType}
 */
proto.cloud.ExpandedEntity.prototype.getDerivativeType = function() {
  return /** @type {!proto.cloud.EntityDerivativeType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.cloud.EntityDerivativeType} value
 * @return {!proto.cloud.ExpandedEntity} returns this
 */
proto.cloud.ExpandedEntity.prototype.setDerivativeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 sub_series = 4;
 * @return {number}
 */
proto.cloud.ExpandedEntity.prototype.getSubSeries = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.ExpandedEntity} returns this
 */
proto.cloud.ExpandedEntity.prototype.setSubSeries = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


goog.object.extend(exports, proto.cloud);
